import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=b10650d2"
var script = {}
import style0 from "./searchBar.vue?vue&type=style&index=0&id=b10650d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports